import {
    CustomerAddressDto,
    CustomerDto,
    EmergencyContactDto,
    SaveCustomerDto
} from 'actions/customer/CustomerDtos';
import { convertToIntakeFormAnswerDto } from 'actions/intakeForm/IntakeFormConverter';
import { convertToPet, convertToSavePetDto } from 'actions/pets/PetsConverter';
import { Customer, CustomerAddress, EmergencyContact } from 'types/Customer';

export const convertToCustomer = (dto: CustomerDto): Customer => ({
    id: dto.id,

    email: dto.email,
    name: dto.first_name,
    lastName: dto.last_name,
    phone: dto.phone,

    active: dto.active,
    blocked: dto.blocked,

    token: dto.token,
    channel: dto.channel,

    pets: dto.pets.map(convertToPet)
});

export const convertToSaveCustomerDto = (
    customer: Customer,
    marketplaceId: number,
    channel: string,
    password?: string
): SaveCustomerDto => {
    return {
        active: customer.active,
        blocked: customer.blocked,

        regenerate_password: false,
        terms_of_service: true,
        phone_optout: false,
        email_optout: false,

        ...(password && {
            password: password,
            password_confirmation: password
        }),

        first_name: customer.name,
        last_name: customer.lastName,
        email: customer.email,
        phone: customer.phone.replace(/\D+/g, ''),

        channel: channel,
        marketplace_id: marketplaceId,

        pets_attributes: customer.pets?.map(pet => convertToSavePetDto(pet, marketplaceId)),
        addresses_attributes:
            customer.addresses?.map(address =>
                convertToCustomerAddressDto(address, marketplaceId)
            ) ?? [],
        authorized_contacts_attributes:
            customer.emergencyContacts?.map(convertToCustomerEmergencyContactDto) ?? [],

        custom_question_responses_attributes:
            customer.answers?.map(convertToIntakeFormAnswerDto) || []
    };
};

export const convertToCustomerAddressDto = (
    address: CustomerAddress,
    marketplaceId: number
): CustomerAddressDto => {
    return {
        marketplace_id: marketplaceId,
        address_line_one: address.addressLineOne,
        address_line_two: address.addressLineTwo,
        city: address.city,
        state: address.state,
        zipcode: address.zipCode,
        country: address.country,
        active: address.active
    };
};

export const convertToCustomerEmergencyContactDto = (
    contact: EmergencyContact
): EmergencyContactDto => {
    return {
        uuid: contact.uuid,
        first_name: contact.name,
        last_name: contact.lastName,
        phone: contact.phone,
        relationship_id: contact.relationship.id,
        emergency_contact: true
    };
};
